import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './ContentTypes.module.css';
import { categoryImages } from 'shared/utility';

const contentTypes = (props) => {
  const ContentTypesContainerStyles = [classes.ContentTypesContainer, classes[props.classIdentifier]];
  if (props.shortWindow === true) ContentTypesContainerStyles.push(classes.ShortWindow);
  const cts = categoryImages.map((contentCategory) => {
    const categoryImage = categoryImages.find((category) => category.name === contentCategory.name);
    const contentCategoryClasses = [classes.ContentCategory];
    const selected =
      props.selectedCategory === contentCategory.name || (props.selectedCategories && props.selectedCategories.includes(contentCategory.name));
    if (selected) contentCategoryClasses.push(classes.Selected);
    return (
      <div className={contentCategoryClasses.join(' ')} onClick={() => props.clicked(categoryImage.name)} key={categoryImage.name}>
        <categoryImage.image />
        {props.classIdentifier === 'FilterCategorySelector' && selected ? (
          <div className={classes.FilterSelected}>
            <FontAwesomeIcon icon="check" className={classes.CheckMark} />
          </div>
        ) : null}
        <h3>{categoryImage.name}</h3>
        {props.classIdentifier === 'TitleCategorySelector' ? <FontAwesomeIcon icon="chevron-right" className={classes.MoreIcon} /> : null}
      </div>
    );
  });
  return <div className={ContentTypesContainerStyles.join(' ')}>{cts}</div>;
};

export default contentTypes;
